/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Wrapped_Summary_Next_SessionInputs */

const en_us2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The next one has already started, and it opens with ${i?.session}.`)
};

const pt_br2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A próxima já começou, e ela abre com o ${i?.session}.`)
};

const es_419_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La próxima ya empezó y arranca con ${i?.session}.`)
};

const pt_pt2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A próxima já começou, e abre com o ${i?.session}.`)
};

const fr_fr2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La suivante a déjà commencé, et elle s'ouvre avec ${i?.session}.`)
};

const de_de2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die nächste hat schon begonnen, und sie startet mit ${i?.session}.`)
};

const it_it2_wrapped_summary_next_session = /** @type {(inputs: Wrapped_Summary_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La prossima è già iniziata, e si apre con ${i?.session}.`)
};

/**
* | output |
* | --- |
* | "The next one has already started, and it opens with {session}." |
*
* @param {Wrapped_Summary_Next_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_next_session = /** @type {((inputs: Wrapped_Summary_Next_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_Next_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_next_session(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_next_session(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_next_session(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_next_session(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_next_session(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_next_session(inputs)
	return en_us2_wrapped_summary_next_session(inputs)
});
export { wrapped_summary_next_session as "wrapped.summary_next_session" }